import { useRef } from 'preact/hooks';
import { IconWrap } from '../components/Icon.tsx';
import { exportData, importBackup } from '../store/backup.ts';
import { live, useStore } from '../store/store.ts';
import { openModal, toast } from '../ui/ui-store.ts';
import { MeetingModal } from '../features/misc/SimpleModals.tsx';

export function MorePage() {
  const meetings = live(useStore((s) => s.meetings));
  const fileInput = useRef<HTMLInputElement>(null);

  async function onFile(e: Event) {
    const input = e.currentTarget as HTMLInputElement;
    const file = input.files?.[0];
    // Reset immediately so re-picking the same file fires change again.
    input.value = '';
    if (!file) return;

    try {
      await importBackup(await file.text());
      toast('Sauvegarde importée');
    } catch {
      alert('Fichier invalide');
    }
  }

  return (
    <section class="page">
      <div class="sectionTitle">
        <div>
          <h1>Plus</h1>
          <p class="muted">Réunions, sauvegarde et outils.</p>
        </div>
        <button class="btn primary" onClick={() => openModal('Nouvelle réunion', <MeetingModal />)}>
          + Réunion
        </button>
      </div>

      <div class="grid3">
        <div class="card">
          <div class="cardHead">
            <IconWrap name="meeting" background="#fff0e6" />
            <div>
              <h3>Réunions & concertations</h3>
            </div>
          </div>

          {meetings.length ? (
            meetings
              .slice()
              .reverse()
              .map((m) => (
                <div key={m.id} class="meeting">
                  <b>{m.title}</b>
                  <div class="small muted">{m.date}</div>
                  <div style={{ marginTop: '6px' }}>{m.notes}</div>
                </div>
              ))
          ) : (
            <div class="empty">Aucune réunion.</div>
          )}
        </div>

        <div class="card">
          <div class="cardHead">
            <IconWrap name="note" background="#e8f3fc" />
            <div>
              <h3>Sauvegarde</h3>
            </div>
          </div>
          <p>Exporte toutes tes données pour les garder à l’abri.</p>
          <div class="row">
            <button class="btn soft" onClick={() => void exportData()}>
              Exporter
            </button>
            <button class="btn" onClick={() => fileInput.current?.click()}>
              Importer
            </button>
          </div>
          <input
            ref={fileInput}
            type="file"
            accept="application/json"
            style={{ display: 'none' }}
            onChange={(e) => void onFile(e)}
          />
        </div>

        <div class="card">
          <div class="cardHead">
            <IconWrap name="cal" background="#eaf6ee" />
            <div>
              <h3>Impression</h3>
            </div>
          </div>
          <p>Imprime la vue actuelle depuis le navigateur.</p>
          <button class="btn soft" onClick={() => window.print()}>
            Imprimer
          </button>
        </div>
      </div>
    </section>
  );
}
